/**
 * The string representation of an org-level RBAC role
 */
export enum RbacRole {
  Admin = "admin",
  Member = "member",
}
